<template>
  <div class="header--bg">
    <div class="header" :class="{'nologin-header': (isRegister || isLogin) && screenSize !== 'MINI'}">
      <!-- logo -->
      
      <div class="header__logo sensors-data">
        <!-- TODO BACK TO HOME -->
        <a href="javasript:void;" v-if="isLogin">
          <img src="@/assets/images/logo_transparent.png" />
        </a>
        <router-link to="/login" v-else-if="isRegister">
          <img src="@/assets/images/logo_transparent.png" />
        </router-link>
        <router-link :to="$route.path" v-else>
          <img src="@/assets/images/logo_transparent.png" />
        </router-link>
        
      </div>
      <!-- 企业信息 -->
      <div class="header__info" v-if="isRegister || hasLogin" :class="{'bg-dbdada': isRegister}">
        <div class="avatar"></div>
        <div v-if="hasLogin" style="display:inline-block;vertical-align:top;">
          <div class="user-info">
            <div>
              <span class="name">金融机构名称：<em>{{$store.state.corpInfo.user.userName}}</em><i class="line">丨</i></span>
              <span class="name">用户角色：<em>{{roleName}}</em><i class="line">丨</i></span>
              <span class="name"><em>{{$store.state.corpInfo.user.personName}}</em>，您好！</span>
            </div>
            <!-- <p class="user-name">{{$store.state.corpInfo.user.userName}}</p> -->
          </div>
          <span class="logout fs-16"><a href="/uaa/logout?redirect_url=/finance/login" target="_self">退出</a></span>
        </div>
        <div v-if="isRegister" class="to-login">
          <p>
            已有账号，
            <router-link to="/login">立即登录</router-link>
          </p>
        </div>
      </div>
    </div>
    <div id="ccbcadiv"></div>
    <div id="ccbcact"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ajax from '@/libs/ajax'
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState(['screenSize']),
    ...mapGetters(['hasLogin']),
    isRegister() {
      return (
        this.$route.path === '/reset-password'
      )
    },
    // 是否是登录页面
    isLogin() {
      return this.$route.path.indexOf('/login') > -1
    },
    roleName () {
      let roleName = ''
      if (this.$store.state.corpInfo.roles.length > 0) {
        if (this.$store.state.corpInfo.roles[0].pkRole === 'ROLE_FINANCE_CLIENT_MANAGER') {
          roleName = '业务查询角色'
        } else {
          roleName = this.$store.state.corpInfo.roles[0].roleName
        }
      }
      return roleName
    }
  },
  created() {
    
  },
  methods: {

  }
}
</script>

<style lang="less">
@import '../styles/var.less';
.header--bg {
  background: #eee;
  width: 100%;
  height: 90px;
  position: fixed;
  top: 0;
  z-index: 999;
}
.header {
  height: 100%;
  position: relative;
  padding: 0 35px 0 65px;
}
.nologin-header {
  width: @page-width;
  margin: 0 auto;
  padding: 0;
}
.header__logo {
  float: left;
  width: 240px;
  img {
    width: 148px;
    // height: 60px;
    display: inline-block;
    margin-top: 25px;
    &.header__guarantee__logo {
      width: auto;
      height: 50px;
      position: relative;
      top: -5px;
    }
    &.config-logo {
      width: auto;
      height: auto;
      max-width: 280px;
      max-height: 50px;
      margin-top: 0;
      position: relative;
      top: 45px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &--divider {
    height: 36px;
    width: 1px;
    margin: 28px 20px 26px;
    background-color: #fff;
    float: right;
  }
  p {
    color: #fff;
    float: right;
    width: 102px;
    line-height: 1.5;
    margin-top: 26px;
  }
  .platform-slogan {
    width: auto;
    line-height: 90px;
    font-size: 18px;
    margin-top: 0;
    max-width: 450px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.header__info {
  float: right;
  // background-color: #dbdada;
  padding-left: 20px;
  height: 90px;
  margin-left: 35px;
  .avatar {
    display: inline-block;
    background: url('../assets/icons/icon_avatar.png') 0 0 no-repeat;
    width: 50px;
    height: 50px;
    margin-right: 15px;
    margin-top: 21px;
  }
  .user-info {
    display: inline-block;
    color: #333;
    vertical-align: top;
    margin-top: 33px;
    .name {
      max-width: 338px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 16px;
      display: inline-block;
    }
    .line {
      padding: 0 10px;
    }
  }
  .logout {
    display: inline-block;
    margin-left: 20px;
    margin-right: 20px;
    height: 100%;
    cursor: pointer;
    line-height: 90px;
    width: 34px;
  }
  .to-login {
    color: #fff;
    display: inline-block;
    vertical-align: top;
    margin-top: 36px;
    margin-right: 20px;
    a {
      color: #fff;
      border-bottom: 1px solid currentColor;
      height: 22px;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.hotline {
  height: 90px;
  line-height: 90px;
  font-size: 16px;
  color: grey;
}
.bg-dbdada {
  background-color: #dbdada;
}
</style>
